var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWhatsapp = function SvgWhatsapp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_833",
    "data-name": "Group 833",
    width: 25.712,
    height: 25.912,
    viewBox: "0 0 25.712 25.912",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Whatsapp_logo",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_831",
    "data-name": "Group 831"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_830",
    "data-name": "Group 830"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_987",
    "data-name": "Path 987",
    d: "M13.09,0A12.625,12.625,0,0,0,2.278,19.14L0,25.912l6.989-2.238A12.623,12.623,0,1,0,13.09,0Zm0,23.234a10.55,10.55,0,0,1-5.839-1.755L3.173,22.785,4.5,18.844a10.609,10.609,0,1,1,8.592,4.39Z",
    fill: "#f4fafa",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_988",
    "data-name": "Path 988",
    d: "M64.626,61.389c-.2-.493-.361-.509-.677-.524-.108-.005-.226-.01-.354-.01a1.537,1.537,0,0,0-1.083.38,3.387,3.387,0,0,0-1.083,2.58,6.02,6.02,0,0,0,1.263,3.2,13.266,13.266,0,0,0,5.286,4.67c2.438,1.01,3.162.92,3.718.8a3.006,3.006,0,0,0,2.083-1.495,2.585,2.585,0,0,0,.181-1.471c-.077-.129-.284-.206-.593-.361s-1.831-.9-2.114-1.006a.6.6,0,0,0-.764.23,12.732,12.732,0,0,1-.83,1.1.667.667,0,0,1-.752.116,7.864,7.864,0,0,1-2.489-1.536A9.319,9.319,0,0,1,64.7,65.916c-.181-.309-.016-.494.123-.662.159-.192.305-.33.46-.511a2.07,2.07,0,0,0,.344-.484.634.634,0,0,0-.044-.574C65.5,63.53,64.883,62.008,64.626,61.389Z",
    transform: "translate(-54.497 -53.987)",
    fill: "#f4fafa",
    fillRule: "evenodd"
  }))));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWhatsapp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/whatsapp.8abe202b.svg";
export { ForwardRef as ReactComponent };